import { HStack, Badge, } from "native-base";
import React, { PropsWithChildren } from "react";
import { useContrastProps, useThemeColors } from "../hooks";
import { Icon } from "../Icon";
import type { TextStyle } from "react-native";

export type TabModeProps = {
    index: number;
    disabled?: boolean;
    active?: boolean;
    isInvalid?: boolean;
};



const ErrorIcon = (props: { color?: string }) => {
    return <Icon type="error" size={4} color={props.color} />;
};


export const WizardMode = (props: PropsWithChildren<TabModeProps>) => {
    const { errorColor } = useThemeColors();
    const activeColor = props.isInvalid ? errorColor : props.active ? "primary.500" : "muted.500";
    const {bg, color} = useContrastProps(activeColor);
    return (
        <HStack space={2} alignItems="center" justifyContent="center" size={"sm"} opacity={props.disabled ? 0.5 : undefined}>
            <Badge bg={bg} _text={{color}}>
                {props.isInvalid ? <ErrorIcon color={color} /> : props.index + 1}
            </Badge>
            {props.children}
        </HStack>
    )
}

export const TabMode = (props: PropsWithChildren<TabModeProps>) => {
    const { errorColor } = useThemeColors();
    return <HStack space={2} alignItems="center" justifyContent="center">
        {props.isInvalid && <ErrorIcon color={errorColor} />}
        {props.children}
    </HStack>
}
